import { styled } from '@styles/stitches.config'

export const Link = styled('button', {
  color: '#1F6ADB',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
})

export const Button = styled('button', {
  display: 'inline-flex',
  lineHeight: 1,
  backgroundColor: 'white',
  border: '1px solid $secondary700',
  borderRadius: '$sm',
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '200ms color, 200ms background-color',
  textAlign: 'center',
  width: '100%',

  '&:disabled': {
    color: '#999999',
    borderColor: '#e6e6e6',
    opacity: 0.75,
  },

  '&:hover': {
    color: '$gray',
    backgroundColor: '$darkGray',
  },

  '& svg': {
    width: '$16',
    height: '$16',
  },

  variants: {
    isSecondary: {
      true: { justifyContent: 'start', mt: '$4', paddingLeft: '0' },
    },
    display: {
      block: {
        display: 'block',
      },
    },
    color: {
      primary: {
        color: '$brand',
      },
      secondary: {
        color: '$textMuted',
      },
      black: {
        color: 'black',
      },
      danger: {
        color: '$alert',
      },
    },
    mode: {
      flat: {
        border: 'none',

        '&:hover': {
          color: 'black',
          backgroundColor: '$darkGray',
        },
      },
      filled: {
        color: 'white',
        backgroundColor: '$brand',
      },
      outline: {
        border: '2px solid $brand',
      },
      ghost: {
        backgroundColor: 'transparent',
        border: 'none',
        color: '$brand',

        '&:hover': {
          color: 'white',
          backgroundColor: '$brand',
        },
      },
      noStyle: {
        border: 'none',
        color: '$textMuted',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
    hideIcon: {
      true: {
        '& svg': {
          display: 'none',
        },
      },
    },
    iconRight: {
      true: {
        '& svg': {
          marginLeft: '$8',
        },
      },
    },
    iconLeft: {
      true: {
        '& svg': {
          marginRight: '$8',
        },
      },
    },
    size: {
      sm: {
        fontSize: 12,
        padding: '$6 $8',
      },
      md: {
        fontSize: 14,
        padding: '$8 $12',
      },
      lg: {
        fontSize: 16,
        padding: '$12 $16',
      },
    },
    loading: {
      true: {
        color: '$textMuted',
        pointerEvents: 'none',
        cursor: 'pointer',
        opacity: 0.75,
      },
    },
  },
  compoundVariants: [
    {
      color: 'primary',
      mode: 'flat',
      css: {
        '&:hover': {
          color: '$brand',
          backgroundColor: 'transparent',
        },
      },
    },
    {
      color: 'primary',
      mode: 'outline',
      css: {
        borderColor: '$brand',
        '&:hover': {
          color: 'white',
          backgroundColor: '$brand',
        },
      },
    },
    {
      color: 'black',
      mode: 'outline',
      css: {
        border: '1px solid rgba(0,0,0,0.1)',
      },
    },
    {
      color: 'primary',
      mode: 'filled',
      css: {
        color: 'white',
        backgroundColor: '$brand',
        '&:hover': {
          color: 'white',
          backgroundColor: '$brand',
        },
        '&:disabled': {
          color: '#999999',
          backgroundColor: '#e6e6e6',
        },
      },
    },
    {
      color: 'danger',
      mode: 'outline',
      css: {
        color: 'black',
        borderColor: '$alert',
      },
    },
    {
      color: 'danger',
      mode: 'filled',
      css: {
        color: 'white',
        backgroundColor: '$alert',
        border: '2px solid $alert',
      },
    },
  ],

  defaultVariants: {
    size: 'lg',
    color: 'primary',
    mode: 'filled',
  },
})
